<template>
<div class="contact_container">
  <MainHeading :title="'Contact'" :subtitle="'Me'" />

  <div class="form_container">
    <p class="notification" :class="formStatus">
      {{ notification }}
    </p>
    <form>
      <input type="text" name="fname" id="fname" placeholder="First Name" required />
      <input type="text" name="lname" id="lname" placeholder="Last Name" required />
      <input type="text" name="email" id="email" placeholder="Email" required />
      <textarea name="message" id="message" cols="30" rows="10" placeholder="Message" required></textarea>
      <input type="submit" value="Submit" id="submitBtn" @click="formSubmit" />
    </form>
  </div>
</div>
</template>

<script src="./Contact.js"></script>

<style src="./Contact.scss" lang="scss"></style>
